// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon;

module.exports.CgChevronRightO = function CgChevronRightO(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M11.0858 7.75739L15.3284 12L11.0858 16.2427L9.67157 14.8285L12.5 12L9.67157 9.1716L11.0858 7.75739Z",
        "fill": "currentColor"
      }
    }, {
      "tag": "path",
      "attr": {
        "fillRule": "evenodd",
        "clipRule": "evenodd",
        "d": "M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12Z",
        "fill": "currentColor"
      }
    }]
  })(props);
};